export default "__VITE_ASSET__98048ba4__"